import { createStore, withProps } from '@ngneat/elf';
import { AcDto, SettingsAc, User } from '@/types';
import { SelectOption } from '@/components/form-builder/form-builder.types';
import { Observable, of } from 'rxjs';

export interface ContractingAuthorityStateProps {
  response?: Partial<SettingsAc>;
  dto?: Partial<AcDto>;
  tuttelSelected?: SelectOption;
  membersSelected?: SelectOption[];
  memberToDelete?: User;
  isDisabled?: Observable<Record<keyof AcDto, boolean>>;
  comSelected?: SelectOption;
  paysSelected?: SelectOption;
  acSelected?: SelectOption;
}

export const contractingAuthorityInitialState: ContractingAuthorityStateProps = {
  response: { id: 0, nom: '', abreviation: '', nomAr: '', contact: '', ancrage: '', users: [], tutel: { id: 0, nom: '', ancrage: '' } },
  dto: {
    nom: '',
    abreviation: '',
    nomAr: '',
    ancrage: null,
    contact: null,
    userIds: [],
    tutelId: null,
    email: '',
    logo: null,
    logoFile: undefined,
    istTutel: false,
    comId: null,
    typeAffCommission: null,
    adresse: {
      id: undefined,
      tel1: '',
      tel2: '',
      fax: '',
      adresse: '',
      compAdresse: '',
      codePostal: '',
      ville: '',
      paysId: null,
    },
  },
  membersSelected: [],
  tuttelSelected: undefined,
  memberToDelete: undefined,
  comSelected: undefined,
  paysSelected: undefined,
  isDisabled: of({
    nom: false,
    abreviation: false,
    nomAr: false,
    tutelId: false,
    contact: false,
    userIds: false,
    ancrage: false,
    email: false,
    logo: false,
    logoFile: false,
    istTutel: false,
    comId: false,
    typeAffCommission: false,
    adresse: false,
  }),
};

export const contractingAuthorityStateStore = createStore(
  { name: 'contracting-authority-state' },
  withProps<ContractingAuthorityStateProps>({ ...contractingAuthorityInitialState })
);
